import Vue from 'vue'
import VueRouter from 'vue-router'

// import Service from './components/Service.vue'
// import DataInfo from './components/DataInfo.vue'
// import Banner from './components/Banner.vue'
// import Download from './components/Download.vue'


/// 路由懒加载的方法 https://router.vuejs.org/zh/guide/advanced/lazy-loading.html#把组件按组分块
const Service = () => import('./components/Service.vue');
const DataInfo = () => import('./components/DataInfo.vue');
const Banner = () => import('./components/Banner.vue');
const Download = () => import('./components/Download.vue');


Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/Download',
      name: 'Download',
      component: Download,
      meta: {
        title: '澈見幸福APP下載'
      }
    },
    {
      path: '/Service',
      name: 'Service',
      component: Service,
      meta: {
        title: '服务条款'
      }
    },
    {
      // path: '/DataInfo/:dataId/test/:testPara',
      path: '/DataInfo/:dataId',
      name: 'DataInfo',
      component: DataInfo,
      props: true,
      meta: {
        title: '詳情'
      }
    },
    {
      path: '/Banner',
      name: 'Banner',
      component: Banner,
      meta: {
        title: 'Banner'
      }
    },
    {
      path: '*',
      redirect: '/Download',
      component: Download,
      meta: {
        title: '澈見幸福APP下載'
      }
    },
  ]
})